export type ManagementProfile = {
  name: string;
  title: string;
  summary: string;
  imagePath: string;
};

export const PURPOSE_PARAGRAPHS: string[] = [
  "Vehicles changed the world. They gave people freedom, mobility, and access to new opportunities.",
  "Yet the process of acquiring, managing, transporting, and selling a vehicle has become increasingly complicated. Disconnected systems, unclear costs, and inefficient steps often stand between people and the outcome they are trying to achieve.",
  "We believe the automotive experience should be simpler.",
  "Buyers should have clearer information and greater control. Sellers and Dealers should be able to respond to real demand, manage vehicles more efficiently, and reduce unnecessary operating costs. Transporters should be able to identify relevant transportation needs and coordinate directly with the people who need their services.",
  "Every part of the process should work together—from identifying and acquiring the right vehicle to managing inventory, arranging transportation, and completing the final sale.",
  "When information is clearer and communication is more direct, decisions become more informed. Relationships become stronger. Time and resources are used more effectively. The process becomes less about navigating obstacles and more about reaching the right outcome.",
  "Across private sales, dealerships, wholesale transactions, and vehicle transportation, the industry does not need another disconnected platform. It needs a more coordinated, transparent, and efficient way to move vehicles from demand to delivery.",
  "Motosport Software is building that future.",
  "A better process for acquiring, managing, transporting, and selling vehicles.",
];

export const MANAGEMENT_PROFILES: ManagementProfile[] = [
  {
    name: "Craig Strickland",
    title: "Co-Founder and CEO",
    summary:
      "Craig is an electrical engineer and seasoned software engineer with more than 30 years of experience. His background includes process improvement, workflow automation, and automotive dealership management. A lifelong vehicle enthusiast, he combines technical expertise with practical industry knowledge to develop more efficient automotive solutions.",
    imagePath: "/images/Craig.webp",
  },
  {
    name: "Billy Stalnaker",
    title: "Co-Founder, CTO, and VP of Software Development",
    summary:
      'Billy is an experienced software architect who has designed and delivered production systems across the full technology stack for more than a decade. His expertise includes AI-powered automation, Kubernetes-based cloud infrastructure, and scalable SaaS products used by Fortune 500 companies. He is also the founder of <a href="https://stalnakergroup.com" class="text-[#BC0319] hover:underline font-medium" target="_blank" rel="noopener noreferrer">The Stalnaker Group</a>, where he leads AI automation and custom application development. Billy brings extensive experience in software architecture, product development, and cloud engineering to Motosport Software.',
    imagePath: "/images/Billy.webp",
  },
  {
    name: "Tom Lynn",
    title: "Co-Founder and VP of Business Development",
    summary:
      "Tom is an accomplished enterprise sales and business development leader with a record of driving growth and building long-term client relationships. His experience includes delivering innovative technology solutions to Fortune 50 companies, large enterprises, and mid-market organizations. He brings a service-focused approach to expanding strategic partnerships and market opportunities for Motosport Software.",
    imagePath: "/images/Tom.webp",
  },
];

export const CAREERS_CONTENT = {
  title: "Help Build What's Next in Automotive Software",
  paragraphs: [
    "Motosport Software is building technology designed to rethink established automotive workflows.",
    "As we grow, we expect to add people with experience in software development, artificial intelligence, data architecture, automotive operations, product development, and customer support.",
    "We value practical problem-solving, direct communication, and a commitment to turning complicated processes into simpler software experiences.",
  ],
  notice: "Current openings will be posted here as positions become available.",
};
